import { useCallback, useState } from 'react';

type UseSendToQueueOptions = {
  hasProFeatures: boolean;
  onProGate: () => void;
};

export function useSendToQueue({
  hasProFeatures,
  onProGate,
}: UseSendToQueueOptions) {
  const [targetClipId, setTargetClipId] = useState<string | null>(null);

  const handleSendToQueue = useCallback((clipId: string) => {
    if (!hasProFeatures) {
      setTargetClipId(null);
      onProGate();
      return;
    }
    setTargetClipId(clipId);
  }, [hasProFeatures, onProGate]);

  const setOpen = useCallback((open: boolean) => {
    if (!open) setTargetClipId(null);
  }, []);

  return {
    targetClipId,
    handleSendToQueue,
    setOpen,
  };
}
